import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable({ providedIn: 'root' })
export class AppManagementHubService extends HubService {
  constructor() {
    super(`${environment.appmanagement.api}/hubs/app-management`);
  }
}
